import cloneDeep from 'clone-deep'
import { generateString } from 'designer/component/action/Data'
import { checkWithDefaultValue, genRefId } from './index'
import {
  onCheckCondition,
  searchCondition,
} from 'designer/component/action/condition/Action'
import objectPath from 'object-path'

export const addJsonTable = (newData, dataUpdate, propAction) => {
  let {
    designContext,
    uischema,
    updateData = () => {},
    stateParent,
  } = propAction
  const {
    render: [render, setRender],
  } = stateParent

  let { jsonForm } = designContext
  let formData = jsonForm.formData
  let tableKey = uischema.key
  let hasAddRowCondition = searchCondition(jsonForm, tableKey, {
    stateKey: 'isAddRow',
  })
  let hasAfterAddRowCondition = searchCondition(jsonForm, tableKey, {
    stateKey: 'isAfterAddRow',
  })
  if (hasAddRowCondition.length > 0) {
    onCheckCondition(designContext, formData, tableKey, {
      dataTable: dataUpdate,
      rowData: [newData],
      isAddRow: true,
      filterCondition: hasAddRowCondition,
    })
  } else if (hasAfterAddRowCondition.length > 0) {
    updateData(dataUpdate)
    onCheckCondition(designContext, formData, tableKey, {
      isAddRow: true,
      filterCondition: hasAfterAddRowCondition,
    })
  } else {
    updateData(dataUpdate)
  }
  setRender(true)
}

export const addSyncTable = (newData, dataUpdate, propAction) => {
  let {
    designContext,
    updateSyncData = () => {},
    syncKey,
    syncName,
  } = propAction
  let { jsonForm } = designContext
  let formData = jsonForm.formData

  let hasAddRowCondition = searchCondition(jsonForm, syncKey, {
    stateKey: 'isAddRow',
  })
  let hasAfterAddRowCondition = searchCondition(jsonForm, syncKey, {
    stateKey: 'isAfterAddRow',
  })
  if (hasAddRowCondition.length > 0) {
    onCheckCondition(designContext, formData, syncKey, {
      dataTable: dataUpdate,
      rowData: [newData],
      isAddRow: true,
      filterCondition: hasAddRowCondition,
    })
  } else if (hasAfterAddRowCondition.length > 0) {
    updateSyncData(syncKey, syncName, dataUpdate)
    onCheckCondition(designContext, formData, syncKey, {
      isAddRow: true,
      filterCondition: hasAfterAddRowCondition,
    })
  } else {
    updateSyncData(syncKey, syncName, dataUpdate)
  }
}

export const onRowTableAdd = (newData, propAction) => {
  let {
    designContext,
    uischema,
    stateParent,
    isLoadSYNC,
    syncKey,
    config,
    updateData,
    formComponentName,
    formData,
  } = propAction
  let { isFavoriteModal, jsonData = [], favoriteDataKey } = config
  let { isUiChanged } = designContext
  let editFavorite = isUiChanged?.editFavorite
  let favoriteJson = objectPath.get(editFavorite, `jsonData.${favoriteDataKey}`)
  const {
    loading: [, setLoading],
  } = stateParent

  setLoading(true)
  let tableKey = isLoadSYNC ? syncKey : uischema.key
  let tableName = uischema.name
  tableKey = formComponentName ? `${formComponentName}.${tableKey}` : tableKey
  tableName = formComponentName
    ? `${formComponentName}.${tableName}`
    : tableName
  let arrayTable = objectPath.get(isUiChanged, `arrayTable.${tableKey}`)
  arrayTable = Array.isArray(arrayTable) ? arrayTable : []
  let formTable =
    objectPath.get(formData, tableName) ||
    objectPath.get(formData, tableKey) ||
    objectPath.get(formData, uischema.name) ||
    objectPath.get(formData, uischema.key) ||
    []
  formTable = Array.isArray(formTable) ? formTable : []

  let newTable = isFavoriteModal
    ? favoriteJson || jsonData
    : arrayTable.length > 0
    ? arrayTable
    : formTable
  let genId = generateString(10)
  objectPath.set(newData, genRefId, genId)
  let dataUpdate = cloneDeep(newTable)
  newData = checkWithDefaultValue(newData, uischema)
  dataUpdate.push(newData)
  if (isFavoriteModal) {
    updateData(dataUpdate)
  } else if (isLoadSYNC) {
    addSyncTable(newData, dataUpdate, propAction)
  } else {
    addJsonTable(newData, dataUpdate, propAction)
  }
  setLoading(false)
  return Promise.resolve()
}
